import { observer } from 'mobx-react'
import React, { memo } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import PageTitle from '../../components/PageTitle'
import DashboardLayout from '../../layouts/DashboardLayout'

const BiPage = props => {
  const linkBi =
    'https://app.powerbi.com/view?r=eyJrIjoiM2VlYjdjMzktMzY0NS00ZGM1LWI1MWEtNTVjODU1ZTVlMjU1IiwidCI6Ijc3M2UyNTU5LTlkMGEtNDBmYi04NmJiLTM1ZjY1Zjc5ODJkNSIsImMiOjEwfQ%3D%3D'

  return (
    <DashboardLayout>
      <Helmet>
        <title>Báo cáo hoạt động SXKD</title>
      </Helmet>
      <PageTitle
        location={props.location}
        title={'Báo cáo hoạt động sản xuất kinh doanh'}
        hiddenGoBack
      />
      <ContentBlockWrapper styles={{ height: '100%' }}>
        <iframe
          title="BÁO CÁO HOẠT ĐỘNG SẢN XUẤT KINH DOANH"
          width="100%"
          height="800"
          src={linkBi}
          frameBorder={0}
          allowFullScreen={true}
        />
      </ContentBlockWrapper>
    </DashboardLayout>
  )
}

BiPage.propTypes = {}

export default memo(observer(BiPage))
